import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const retrieveGuides = async () => {
  try {
    const response = await axios.get(`${apiUrl}/api/internal/quickguides/`);
    return response.data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};
